export default __webpack_public_path__ + "static/media/flow3.a1629272.svg";